import { router } from '@/app/router';
import { store } from '@/app/store';
import { session } from '@/services/Session';
import { sentryService } from '@/services/telemetry/sentry';
import {
  type TelemetryFailureReport,
  track,
} from '@/shared/utils/track-telemetry';

interface PrivacyConsentKiosk {
  privacy_policy_variant?: unknown;
  show_privacy_popup?: boolean | null;
}

export function kioskRequiresPrivacyConsent(
  kiosk: PrivacyConsentKiosk | null | undefined
): boolean {
  return kiosk?.show_privacy_popup ?? Boolean(kiosk?.privacy_policy_variant);
}

// The caller gives the report function, because the console text is different
// for each step.
export function redirectToPrivacyConsentIfNeeded(
  next: string,
  breadcrumbData: Record<string, unknown>,
  report: TelemetryFailureReport
): boolean {
  if (
    !(kioskRequiresPrivacyConsent(store.kiosk) && session.gdprConsent !== true)
  ) {
    return false;
  }

  track(
    '[Sentry] Tracking failed:',
    () => {
      sentryService.addBreadcrumb(
        'navigation',
        'Redirecting to GDPR consent',
        breadcrumbData
      );
    },
    report
  );
  router.redirectToStep('gdpr-consent', { query: { next } });
  return true;
}
